import { createSelector } from '@ngrx/store';
import { tryGet } from '../../../shared/utils/func';
import { currentProductInstallationType } from './product-installation-types.state';

export const currentProductInstallationTypeTitle = createSelector(currentProductInstallationType, tryGet('type'));
